export const GET_AUTH_CONNECTIONS = 'getAuthConnections';
export const GET_AUTH_CONNECTION = 'getAuthConnection';
export const CREATE_AUTH_CONNECTION = 'createAuthConnection';
export const UPDATE_AUTH_CONNECTION = 'updateAuthConnection';
export const GET_REFERENCES = 'getReferences';
export const DELETE_AUTH_CONNECTION = 'deleteAuthConnection';
export const GET_USER_VISIBLE_COLUMNS = 'getUserVisibleColumns';
export const VALIDATE_AUTH_CONNECTION = 'validateAuthConnection';
